<template>
  <div>
    <div class="Sidebar" :class="{ 'is-closed': isClosed }">
      <div>
        <div class="main">タスク管理システム</div>
        <div class="close-button" @click="toggleSidebar">
          <svg-icon type="mdi" :path="mdiChevronDoubleLeft"></svg-icon>
        </div>
      </div>
      <br />
      <div class="main">
        {{ "ようこそ " + userName + "さん" }}
      </div>
      <div class="logout-buttons">
        <v-btn @click="showPopup = true" variant="plain">
          ✏️新規ページ作成
        </v-btn>
      </div>
      <div class="button-container">
        <div class="scrollable-container">
          <div v-for="(screen, index) in screens" :key="index" class="nav-button" @click="handleClick(screen.id)"
            @contextmenu.prevent="openContextMenu(screen, $event)">
            {{ screen.name }}
          </div>
        </div>
      </div>
      <div class="logout-buttons">
        <v-btn @click="logout" variant="plain">🔓ログアウト</v-btn>
      </div>
    </div>
    <div class="toggle-button-container" v-if="isClosed && !isLoginPage">
      <button class="toggle-button" @click="toggleSidebar">
        <svg-icon type="mdi" :path="mdiChevronDoubleRight"></svg-icon>
      </button>
    </div>

    <v-dialog v-model="showPopup" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">新しいページ追加</span>
        </v-card-title>
        <v-card-subtitle>
          <label>画面名:</label>
          <v-text-field v-model="newScreen.name" placeholder="画面名を入力してください(20文字まで)" maxlength="20" />
          <label>画面説明:</label>
          <v-text-field v-model="newScreen.explanation" placeholder="画面説明を入力してください(100文字まで)" maxlength="100" />
          <label>ボードビュー名:</label>
          <v-text-field v-model="newScreen.boardView" placeholder="ボードビューを入力してください(20文字まで)" maxlength="20" />
          <label>パスワード:</label>
          <v-text-field v-model="newScreen.password" placeholder="パスワードを入力してください(10文字まで)" maxlength="10" />
        </v-card-subtitle>
        <v-card-actions class="d-flex justify-between">
          <v-btn @click="closePopup" color="red" style="width: 15%">キャンセル</v-btn>
          <v-btn @click="checkName" color="green" style="width: 15%">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu v-model="isContextMenuVisible" :close-on-content-click="false" :activator="contextActivator" absolute
      :style="{
        position: 'absolute',
        top: rightClickPosition.y + 'px',
        left: rightClickPosition.x + 'px',
        transform: 'scale(0.8)',
        transformOrigin: 'top left',
      }">
      <v-list dense>
        <template v-if="
          (['🏠ホーム', '営業対象者画面', 'ゴミ箱'].includes(contextScreen.name))">
          <v-list-item @click="showAlert">
            <v-list-item-title>名前変更</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showAlert">
            <v-list-item-title>削除</v-list-item-title>
          </v-list-item>
        </template>

        <template v-else>
          <v-list-item @click="renameScreen(contextScreen)">
            <v-list-item-title>名前変更</v-list-item-title>
          </v-list-item>
          <v-list-item @click="confirmDelete(contextScreen)">
            <v-list-item-title>削除</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <div>
      <v-dialog v-model="isRenaming" persistent width="30%">
        <v-card>
          <v-card-title class="text-h6"> 名前変更 </v-card-title>
          <v-card-text>
            <v-text-field v-model="newName" label="新しい名前を入力してください(20文字まで)" placeholder="名前を入力" outlined maxlength="20"
              @keyup.enter="checkRename" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="checkRename">確認</v-btn>
            <v-btn color="red" text @click="cancelRename">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isPasswordDialogVisible" persistent max-width="400">
  <v-card>
    <v-card-title>パスワード確認</v-card-title>
    <v-card-text>
      <v-text-field
        v-model="passwordInput"
        label="パスワード"
        type="password"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="blue darken-1" text @click="isPasswordDialogVisible = false">キャンセル</v-btn>
      <v-btn color="red darken-1" text @click="deleteWithPassword">確認</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronDoubleRight, mdiChevronDoubleLeft } from "@mdi/js";
import createNewApi from "@/api/createNew";
import homeApi from "@/api/home";
import deleteApi from "@/api/delete";
import sidebar from "@/api/sidebar";
import eventBus from "@/eventBus";
import auth from "@/api/auth"

export default {
  name: "SidebarComponent",
  props: {
    getDataFromApi: Function,
  },

  components: {
    SvgIcon,
  },
  data() {
    return {
      contextScreen: [
        {
          screenId: null,
          screenName: "",
          screenExplanation: "",
          tableId: null,
        }
      ],
      userName: null,
      authUserId: null,
      sessionKey: "",
      isClosed: false,
      showPopup: false,
      screens: [{ id: "", name: "" }],
      isContextMenuVisible: false,
      rightClickPosition: { x: 0, y: 0 },
      selectedScreen: null,
      isRenaming: false,
      newName: "",
      newScreen: {
        name: "",
        explanation: "",
        boardView: "",
        password: "",
      },
      mdiChevronDoubleRight,
      mdiChevronDoubleLeft,
      items: [],
      menuItems: [],
      ErrMsg: null,
      selectedScreenName: "",
      selectedScreenExplanation: "",
      selectedScreenTableId: "",
      isPasswordDialogVisible: false,
      passwordInput: '',
      screenToDelete: null,
    };
  },
  mounted() {
    this.authUserId = localStorage.getItem("authUserId");
    this.sessionKey = localStorage.getItem("sessionKey");
    this.fetchData();
    this.userName = localStorage.getItem("staffName");
    document.addEventListener("click", this.outsideClick);
    this.isClosed = window.location.pathname === "/login";
    this.isLoginPage = window.location.pathname === "/login";

    eventBus.on("refreshSidebar", this.fetchData);
  },
  watch: {
    $route: async function (newRoute) {
      this.currentUrl = newRoute.path;
      this.screenIdFromUrl = this.currentUrl.split("/")[1];
      await this.fetchData();
      const selectedScreenData = this.items.find(
        (item) => item.screen_id === parseInt(this.screenIdFromUrl)
      );

      if (selectedScreenData) {
        const screenData = {
          screenName: selectedScreenData.screen_name,
          screenExplanation: selectedScreenData.screen_explanation,
          tableId: selectedScreenData.id,
        };
        this.$emit("updateScreenInfo", screenData);
      }
    },
  },
  methods: {
    async fetchData() {
      try {
        this.authUserId = localStorage.getItem("authUserId");
        this.sessionKey = localStorage.getItem("sessionKey");
        const result = await homeApi.getTaskList(
          this.authUserId,
          this.sessionKey,
          ""
        );
        if (result.data) {
          this.items = result.data;
          this.ErrMsg = null;
          this.menuItems = [];
          this.screens = [];
          this.screens.push({
            id: "home",
            name: "🏠ホーム",
          });
          this.items
            .filter((item) => item.screenName === "営業対象者画面")
            .forEach((item) => {
              this.screens.push({
                id: item.screenId,
                name: item.screenName,
                explanation: item.screenExplanation,
                tableId: item.tableId,
              });
            });

          this.items
            .filter((item) => item.screenName !== "営業対象者画面")
            .forEach((item) => {
              this.screens.push({
                id: item.screenId,
                name: item.screenName,
                explanation: item.screenExplanation,
                tableId: item.tableId,
              });
            });
          this.screens.push({
            id: "trash",
            name: "ゴミ箱",
          });
          if (this.selectedScreen) {
            this.selectedScreenName = this.selectedScreen.name;
            this.selectedScreenExplanation = this.selectedScreen.explanation;
            this.selectedScreenTableId = this.selectedScreen.tableId;
            const screenData = {
              screenName: this.selectedScreenName,
              screenExplanation: this.selectedScreenExplanation,
              tableId: this.selectedScreenTableId,
            };
            this.$emit("updateScreenInfo", screenData);
          }
        } else {
          this.ErrMsg = "画面のデータが存在しません。" + result;
          this.items = [];
          this.menuItems = [];
        }
      } catch (error) {
        this.ErrMsg = "エラーが発生しました。\n" + error.message;
        this.items = [];
      }
    },
    logout() {
      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");

      if (authUserId && sessionKey) {
        auth.logout(authUserId, sessionKey)
          .finally(() => {
            localStorage.clear();
            sessionStorage.clear();
            console.log("ログアウト成功")
            this.$router.push("/login");
          });
      } else {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push("/login");
      }
    },
    showAlert() {
      alert("この画面は削除または変更できません。");
    },
    outsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.isContextMenuVisible = false;
      }
    },
    getScreenDataById(screenId) {
      return this.screens.find((screen) => screen.id === screenId) || null;
    },
    async navigateTo(screen_id) {
      const screen = this.screens.find((item) => item.id === screen_id);
      if (screen) {
        this.selectedScreen = screen;
        this.selectedScreenName = screen.name;
        this.selectedScreenExplanation = screen.explanation;
        this.selectedScreenTableId = screen.tableId;
        this.$router.push({ path: `/${screen_id}` });
        const screenData = {
          screenId: screen_id,
          screenName: this.selectedScreenName,
          screenExplanation: this.selectedScreenExplanation,
          tableId: this.selectedScreenTableId,
        };

        this.$emit("updateScreenInfo", screenData);
        sessionStorage.setItem("screenData", JSON.stringify(screenData));
        sessionStorage.setItem("tableId", this.selectedScreenTableId);
      } else {
        this.ErrMsg = "該当する画面が見つかりません。";
      }
      this.fetchData();
    },
    handleClick(screen_id) {
      this.navigateTo(screen_id);
    },
    toggleSidebar() {
      this.isClosed = !this.isClosed;
      // this.isContextMenuVisible = !this.isContextMenuVisible;
      this.$emit("update-is-closed", this.isClosed);
    },
    openContextMenu(screen, event) {
      event.preventDefault();
      this.contextScreen = screen;
      this.isContextMenuVisible = true;
      this.rightClickPosition = { x: event.pageX, y: event.pageY };
    },
    confirmDelete(screen) {
      if (confirm("本当に削除しますか？")) {
        this.screenToDelete = screen;
        this.passwordInput = '';
        this.isPasswordDialogVisible = true;
  }
    },
    deleteWithPassword() {
  if (!this.passwordInput) {
    alert("パスワードを入力してください。");
    return;
  }

  this.isPasswordDialogVisible = false;
  if (this.screenToDelete) {
    this.deleteScreen(this.screenToDelete.id, this.passwordInput);
  }
},
  deleteScreen(screen_id, password) {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        const result = deleteApi.deleteTaskList(
          screen_id,
          password,
          authUserId,
          sessionKey,
          staffName
        );
        setTimeout(() => {
          this.fetchData();
          eventBus.emit("refreshHomePage");
          eventBus.emit("refreshTrash");
        }, 1000);

        if (result) {
          const currentScreenId = Number(this.$router.currentRoute.value.fullPath.replaceAll('/', ''))
          if(currentScreenId === screen_id){
              this.$router.push('/home');
          }
          console.log(result.message);
        } else {
          console.error("画面削除に失敗しました" + result.message);
        }
      } catch (error) {
        console.error("エラーが発生しました" + error.message);
      }
    },
    renameScreen(screen) {
      this.isRenaming = true;
      this.newName = screen.name;
      this.screen_id = screen.id;
      this.isContextMenuVisible = false;
    },
    checkRename() {
      const invalidNames = this.screens.map((screen) => screen.name);
      invalidNames.push("ホーム", "営業対象者画面", "ゴミ箱");
      if (invalidNames.includes(this.newName)) {
        alert("既に存在している画面です。他の画面名を入力してください。");
      } else {
        this.confirmRename();
      }
    },
    async confirmRename() {
      if (!this.newName.trim()) {
        alert("画面名を入力してください。");
        return;
      }

      if (this.newName.trim()) {
        try {
          this.selectedScreen.name = this.newName.trim();
          this.isRenaming = false;

          const authUserId = localStorage.getItem("authUserId");
          const sessionKey = localStorage.getItem("sessionKey");
          const staffName = localStorage.getItem("staffName");

          // 画面名を更新する API 呼び出し（非同期処理）
          const result = await sidebar.updateScreen(
            this.selectedScreen.id,
            this.newName.trim(),
            authUserId,
            sessionKey,
            staffName
          );

          // APIのレスポンス結果をログに出力
          console.log("updateScreen result:", result);

          // APIの戻り値が正しい場合のみ処理を続ける
          if (result) {
            alert("画面名が正常に保存されました。");
            this.fetchData(); // データ再取得
            eventBus.emit("refreshHomePage");
          } else {
            alert("画面名の保存に失敗しました。");
          }
        } catch (error) {
          this.ErrMsg = "エラーが発生しました。\n" + error.message;
          alert("画面名の保存中にエラーが発生しました：" + error.message);
        }
      }
    },
    cancelRename() {
      this.isRenaming = false;
      this.newName = "";
    },
    closePopup() {
      this.showPopup = false;
    },
    checkName() {
      const invalidNames = this.screens.map((screen) => screen.name);
      invalidNames.push("ホーム", "ゴミ箱");
      if (invalidNames.includes(this.newScreen.name)) {
        alert("既に存在している画面です。他の画面名を入力してください。");
      } else {
        this.addScreen();
      }
    },
    async addScreen() {
      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");

      // 画面名が未入力の場合
      if (!this.newScreen.name) {
        alert("画面名を入力してください。");
        return;
      }

      if (!Array.isArray(this.screens)) {
        this.screens = [];
      }

      const newPage = {
        name: this.newScreen.name,
        explanation: this.newScreen.explanation,
        boardView: this.newScreen.boardView,
        password: this.newScreen.password
      };

      // 新しい画面を一時的に追加
      this.screens.push(newPage);
      this.newScreen = { name: "", explanation: "", boardView: "", password: "" };
      this.showPopup = false;

      try {
        // 新規画面作成APIの呼び出し
        const result = await createNewApi.createNew(
          newPage,
          staffName,
          authUserId,
          sessionKey
        );

        // デバッグ用に結果を詳細に表示
        console.log("APIレスポンス: ", result); // ここで返されるレスポンス全体を表示
        console.log("レスポンスの詳細:");
        console.log("result: ", result); // resultオブジェクトの全体
        console.log("成功かどうか: ", result && result.status == 201); // success フィールドがある場合の判定

        // APIの結果による処理
        if (result && result.status == 201) {
          // success フィールドが正しいか確認
          // 保存成功時にアラート表示
          alert("ページが正常に保存されました。");

          // データを再取得
          await this.fetchData();

          // 最新の画面IDを取得し、その画面に遷移
          const latestScreenId = this.screens.reduce((max, screen) => {
            return typeof screen.id === "number" && screen.id > max
              ? screen.id
              : max;
          }, 0);

          if (latestScreenId > 0) {
            this.navigateTo(latestScreenId);
          } else {
            console.error("Invalid screen_id:", latestScreenId);
          }
        } else if (result && result.status == 409) { 
          alert("すでにゴミ箱にある画面名と重複しています");
          await this.fetchData();
        }
        else if (result && result.status !== 409) { 
          // 保存失敗時にアラート表示
          alert("ページの保存に失敗しました。");
        }
      } catch (error) {
        // エラーが発生した場合の処理
        alert("保存中にエラーが発生しました：" + error.message);
        console.error("エラーが発生しました:", error);
      }
    },
  },
};
</script>

<style>
.img {
  width: 30px;
  height: 30px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 20px;
  width: 300px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  transform: translateX(-150%);
}

.popup-content h2 {
  margin-top: 0;
}

.popup-content label {
  display: block;
  margin: 10px 0 5px;
}

.popup-content input {
  width: 100%;
  padding: 5px;
  margin-bottom: 15px;
  box-sizing: border-box;
}

.popup-buttons {
  display: flex;
  justify-content: flex-end;
}

.popup-buttons button {
  margin-left: 10px;
}

.context-menu {
  position: fixed;
  border-radius: 8px;
  background-color: #ffffff;
  color: #333333;
  display: flex;
  flex-direction: column;
  width: 100px;
  z-index: 9999px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.context-menu button {
  width: 100%;
  padding: 10px;
  text-align: center;
  border: none;
  background-color: white;
  color: #333333;
  cursor: pointer;
  font-size: 12px;
  border-radius: 8px;
}

.context-menu button:hover {
  background-color: #e0e0e0;
  color: #000000;
}

.rename-input {
  position: absolute;
  background-color: white;
  padding: 10px;
  border: 1px solid #ddd;
  top: 50px;
  left: 10%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.rename-input button.confirm-renmae {
  border: 2px solid black;
}

.rename-input button.cancel-rename {
  border: 2px solid black;
}

.rename-input input {
  padding: 5px;
  margin-right: 10px;
}

.Sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 15%;
  height: 100%;
  background-color: #fafafa;
  border-right: 1px solid #f2f2f2;
  border-top: 1px solid F2F2F2;
  border-bottom: 1px solid F2F2F2;
  color: #36362e;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  align-items: normal;
  overflow: hidden;
}

.button-container {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  flex: 1;
  overflow: hidden;
  cursor: pointer;
}

.is-closed {
  transform: translateX(-100%);
}

.main {
  margin-top: 15px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: bold;
  position: relative;
  text-align: left;
}

.close-button {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: transparent;
  border: none;
  color: black;
}

.toggle-button {
  cursor: pointer;
  padding: 10px;
  background-color: transparent;
  border: none;
  color: black;
}

.nav-button {
  text-align: left;
  padding: 10px;
  margin-left: 5%;
  font-size: 13px;
  font-weight: bold;
  border: 1px solid transparent;
  border-radius: 10px;
  /* transition: background-color 0.3s, border-color 0.3s; */
}

.nav-button:hover {
  background-color: blue;
  border: none;
  color: white;
  border-radius: 5px;
}

.toggle-button-container {
  position: fixed;
  top: 10px;
  left: 10px;
}

.add-screen-button {
  display: block;
  width: 90%;
  margin: 20px auto;
  padding: 10px;
  background-color: #e0e0e0;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.scrollable-container {
  max-height: 100%;
  overflow-y: auto;
  padding-right: 10px;
}

.home-buttons {
  margin-top: 20px;
}

.logout-buttons {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
  margin-bottom: 30px;
}

.buttonborder {
  color: black;
  border: 2px solid black;
}
</style>
